import React, {CSSProperties, FC, PropsWithChildren, ReactNode, Ref} from "react";
import "../../Styles/PublicRegistrationPage.css";
import "./ui.css";

type PublicShellProps = PropsWithChildren<{
    toolbar?: ReactNode;
    // Logo and title; when set, the toolbar sits beside it in the page header.
    header?: ReactNode;
    live?: boolean;
    busy?: boolean;
    // Iframe-safe layout: no full-viewport height and a plain background.
    embedded?: boolean;
    // Scoped CSS variables, e.g. the per-event public theme.
    style?: CSSProperties;
    // The page root, e.g. for the embedded registration height reporter.
    mainRef?: Ref<HTMLElement>;
}>;

// The one centered column every public (participant-facing) page uses.
export const PublicShell: FC<PublicShellProps> = ({toolbar, header, live, busy, embedded, style, mainRef, children}) => (
    <main ref={mainRef} className={`public-registration-page${embedded ? " public-registration-page--embed" : ""}`} style={style}>
        <section
            className="public-registration-shell"
            aria-live={live ? "polite" : undefined}
            aria-busy={busy || undefined}
        >
            {header ? (
                <header className="public-registration-header">
                    {header}
                    {toolbar ? <div className="public-registration-language">{toolbar}</div> : null}
                </header>
            ) : toolbar ? <div className="public-shell__toolbar">{toolbar}</div> : null}
            {children}
        </section>
    </main>
);
